module.exports = __webpack_public_path__ + "img/img5-6.e8a8af92.jpg";